import React, { useEffect, useState } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

interface RevisionCountdownProps {
  startedAt: number;
  timeoutMs: number;
}

export const RevisionCountdown: React.FC<RevisionCountdownProps> = ({
  startedAt,
  timeoutMs,
}) => {
  const [elapsed, setElapsed] = useState(() => Date.now() - startedAt);

  useEffect(() => {
    setElapsed(Date.now() - startedAt);
    const id = window.setInterval(() => {
      setElapsed(Date.now() - startedAt);
    }, 1000);
    return () => window.clearInterval(id);
  }, [startedAt]);

  const remainingMs = Math.max(0, timeoutMs - elapsed);
  const remainingSec = Math.ceil(remainingMs / 1000);
  const minutes = Math.floor(remainingSec / 60);
  const seconds = remainingSec % 60;
  const progress = (remainingMs / timeoutMs) * 100;

  return (
    <Box sx={{ mt: 1.5 }}>
      <Typography variant="caption" color="text.secondary">
        Waiting for revised outline... {minutes}:{seconds < 10 ? "0" : ""}{seconds} remaining
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ mt: 0.5, height: 4, borderRadius: 2 }}
        color="info"
      />
    </Box>
  );
};
